<div class="content-box">
  <app-breadcrumb [pagina]="tituloTrilha()"></app-breadcrumb>

  @if (!consultou()) {
  <div class="acompanhar-topo">
    <h1 class="acompanhar-titulo">Acompanhamento de Solicitação</h1>
    <p class="acompanhar-subtitulo">
      Consulte o andamento pelo número do protocolo ou acesse sua conta para ver todas as suas
      manifestações.
    </p>

    <div class="new-alert mt-2 mb-3">
      <div class="new-alert-content">
        <i-lucide name="info" size="14" color="#0d6efd"></i-lucide>
        <p class="mb-0">
          Consulte aqui os protocolos registrados neste portal: solicitações de serviço e pedidos de
          acesso à informação (e-SIC). Protocolos criados por outros canais de atendimento não estão
          disponíveis para consulta online.
        </p>
      </div>
    </div>
  </div>

  <div class="acompanhar-divisao">
    <section class="acompanhar-cartao" aria-labelledby="consulta-titulo">
      <h2 class="acompanhar-oculto" id="consulta-titulo">Consultar por protocolo</h2>

      <form class="acompanhar-form" novalidate (submit)="consultar($event)">
        <div class="acompanhar-campo">
          <label class="acompanhar-rotulo" for="consulta-protocolo">Número do Protocolo</label>
          <div class="acompanhar-entrada" [class.acompanhar-entrada-erro]="erroProtocolo()">
            <i-lucide class="acompanhar-entrada-icone" name="search" size="18" aria-hidden="true"></i-lucide>
            <input id="consulta-protocolo" class="acompanhar-entrada-input" type="text" autocomplete="off"
              placeholder="Ex: PM-2026-98754" [value]="protocolo()"
              [attr.aria-invalid]="erroProtocolo() ? 'true' : null"
              [attr.aria-describedby]="erroProtocolo() ? 'erro-protocolo' : null"
              (input)="aoDigitarConsulta('protocolo', $event)" />
          </div>
          @if (erroProtocolo()) {
          <p class="acompanhar-erro" id="erro-protocolo">{{ erroProtocolo() }}</p>
          }
        </div>

        <div class="acompanhar-campo">
          <label class="acompanhar-rotulo" for="consulta-cpf">
            CPF <span class="acompanhar-rotulo-opcional">(opcional)</span>
          </label>
          <div class="acompanhar-entrada" [class.acompanhar-entrada-erro]="erroCpf()">
            <i-lucide class="acompanhar-entrada-icone" name="id-card" size="18" aria-hidden="true"></i-lucide>
            <input id="consulta-cpf" class="acompanhar-entrada-input" type="text" inputmode="numeric" autocomplete="off"
              maxlength="14" placeholder="000.000.000-00" [value]="cpf()"
              [attr.aria-invalid]="erroCpf() ? 'true' : null" [attr.aria-describedby]="erroCpf() ? 'erro-cpf' : null"
              (input)="aoDigitarCpf($event)" />
          </div>
          @if (erroCpf()) {
          <p class="acompanhar-erro" id="erro-cpf">{{ erroCpf() }}</p>
          }
        </div>

        <div class="acompanhar-campo">
          <span class="acompanhar-rotulo" id="captcha-rotulo">Verificação de Segurança</span>

          <div class="acompanhar-captcha" [attr.aria-busy]="estadoCaptcha() === 'carregando'">
            @switch (estadoCaptcha()) {
              @case ('pronto') {
              <img class="acompanhar-captcha-imagem" [src]="imagemCaptcha()"
                alt="Digite os seis caracteres exibidos na imagem." width="220" height="64" />
              }
              @case ('carregando') {
              <p class="acompanhar-captcha-aviso">Carregando código…</p>
              }
              @case ('falha') {
              <p class="acompanhar-captcha-aviso" role="alert">
                Não foi possível carregar o código.
                <button type="button" class="acompanhar-captcha-link" (click)="carregarCaptcha()">Tentar novamente</button>
              </p>
              }
            }

            <div class="acompanhar-captcha-entrada">
              <label class="acompanhar-captcha-ajuda" for="consulta-captcha">Digite os caracteres acima</label>
              <input #campoCaptcha id="consulta-captcha" class="acompanhar-entrada-input acompanhar-captcha-input"
                type="text" autocomplete="off" autocapitalize="characters" spellcheck="false" maxlength="6"
                [value]="captchaDigitado()"
                [attr.aria-invalid]="erroCaptcha() ? 'true' : null"
                [attr.aria-describedby]="erroCaptcha() ? 'erro-captcha' : null"
                (input)="aoDigitarConsulta('captchaDigitado', $event)" />
            </div>

            <button type="button" class="acompanhar-captcha-trocar" [disabled]="estadoCaptcha() === 'carregando'"
              (click)="trocarCaptcha()">
              <i-lucide name="rotate-ccw" size="16" aria-hidden="true"></i-lucide>
              <span class="acompanhar-oculto">Gerar outro código de verificação</span>
            </button>
          </div>

          @if (erroCaptcha()) {
          <p class="acompanhar-erro" id="erro-captcha">{{ erroCaptcha() }}</p>
          }

          <p class="acompanhar-ajuda">
            Não consegue ler o código?
            <button type="button" class="acompanhar-captcha-link" (click)="focarLogin()">Entre na sua conta</button>
            para acompanhar suas solicitações.
          </p>
        </div>

        @if (erroConsulta()) {
          <p class="acompanhar-erro-consulta" role="alert">{{ erroConsulta() }}</p>
        }

        <button type="submit" class="acompanhar-enviar" [disabled]="consultandoApi()" [attr.aria-busy]="consultandoApi()">
          {{ consultandoApi() ? 'Consultando...' : 'Consultar Solicitação' }}
        </button>
      </form>
    </section>

    <section class="acompanhar-cartao acompanhar-cartao-acesso" aria-labelledby="login-titulo">
      <app-login-card destino="/area-cidadao?aba=solicitacoes"></app-login-card>
    </section>
  </div>
  } @else if (naoEncontrado()) {
  <section class="acompanhar-vazio" aria-labelledby="nao-encontrado-titulo">
    <span class="acompanhar-vazio-icone" aria-hidden="true">
      <i-lucide name="triangle-alert" size="40"></i-lucide>
    </span>

    <h1 class="acompanhar-vazio-titulo" id="nao-encontrado-titulo">Protocolo Não Encontrado</h1>

    <p class="acompanhar-vazio-texto">
      Não conseguimos localizar nenhuma manifestação associada ao número de protocolo informado.
      Por favor, verifique se houve algum erro de digitação e tente novamente.
    </p>

    <div class="acompanhar-dicas">
      <p class="acompanhar-dicas-titulo">Dicas para digitação:</p>
      <ul class="acompanhar-dicas-lista">
        <li>
          Certifique-se de incluir as letras e traços correspondentes (ex: CSE-2026-000123-K7Q4X ou
          SIC-2026-000123-K7Q4X).
        </li>
        <li>O número do protocolo é enviado no e-mail de confirmação do registro.</li>
      </ul>
    </div>

    <button type="button" class="acompanhar-enviar acompanhar-enviar-estreito" (click)="novaConsulta()">
      Tentar Novamente
    </button>
  </section>
  } @else if (modoLista()) {
  <div class="acompanhar-topo">
    <h1 class="acompanhar-titulo">Minhas solicitações</h1>
    <p class="acompanhar-subtitulo">Acompanhe o status das suas solicitações de serviços.</p>
  </div>

  <ng-container [ngTemplateOutlet]="barraFiltros"></ng-container>

  <p class="acompanhar-contagem" role="status">
    {{ total() }} {{ total() === 1 ? 'solicitação encontrada' : 'solicitações encontradas' }}
  </p>

  @if (total()) {
  <div class="acompanhar-cabecalho" aria-hidden="true">
    <span>Protocolo</span>
    <span>Descrição</span>
    <span>Status</span>
  </div>

  <ul class="acompanhar-lista">
    @for (item of resultadosDaPagina(); track item.protocolo) {
    <li>
      <button type="button" class="acompanhar-item" (click)="abrirDetalhe(item)">
        <span class="acompanhar-item-identificacao">
          <strong class="acompanhar-item-protocolo">{{ item.protocolo }}</strong>
          <span class="acompanhar-item-data">{{ dataFormatada(item.abertaEm) }}</span>
          <span class="acompanhar-categoria" [attr.data-categoria]="item.categoria">
            <i-lucide [name]="iconeCategoria(item.categoria)" size="12" aria-hidden="true"></i-lucide>
            <span class="acompanhar-oculto">Classificação:</span>
            {{ rotuloCategoria(item.categoria) }}
          </span>
        </span>

        <span class="acompanhar-item-corpo">
          <strong class="acompanhar-item-servico">{{ item.servico }}</strong>
          <!-- O agendamento feito pela área do cidadão não tem descrição nem endereço. -->
          @if (item.descricao) {
          <span class="acompanhar-item-descricao">{{ item.descricao }}</span>
          }
          @if (item.endereco) {
          <span class="acompanhar-item-endereco">
            <i-lucide name="map-pin" size="14" aria-hidden="true"></i-lucide>
            {{ item.endereco }}
          </span>
          }
        </span>

        <span class="acompanhar-status" [attr.data-status]="item.status">
          {{ rotuloStatus(item.status) }}
        </span>
      </button>
    </li>
    }
  </ul>

  <app-paginacao variante="simples" rotulo="Paginação dos protocolos encontrados" [paginaAtual]="paginaAtual()"
    [totalPaginas]="totalPaginas()"
    [resumo]="'Exibindo ' + primeiroDaPagina() + ' a ' + ultimoDaPagina() + ' de ' + total() + ' solicitações'"
    (paginaMudou)="irParaPagina($event)">
    <label class="acompanhar-paginacao-tamanho">
      Itens por página:
      <select class="acompanhar-select acompanhar-select-compacto" [value]="itensPorPagina()"
        (change)="aoTrocarItensPorPagina($event)">
        <option [value]="10">10</option>
        <option [value]="20">20</option>
        <option [value]="50">50</option>
      </select>
    </label>
  </app-paginacao>
  } @else {
  <ng-container [ngTemplateOutlet]="semResultadoDoFiltro"></ng-container>
  }
  } @else {
  <div class="acompanhar-topo acompanhar-topo-acoes">
    <div>
      <h1 class="acompanhar-titulo">{{ tituloResultado() }}</h1>
      <p class="acompanhar-subtitulo">{{ subtituloResultado() }}</p>
    </div>

    @if (unica()) {
    <div class="acompanhar-acoes">
      <button type="button" class="acompanhar-acao" (click)="imprimir()">
        <i-lucide name="printer" size="16" aria-hidden="true"></i-lucide>
        Imprimir
      </button>

      <button type="button" class="acompanhar-acao acompanhar-acao-primaria" [disabled]="gerandoPdf()"
        (click)="baixarPdf()">
        <i-lucide name="download" size="16" aria-hidden="true"></i-lucide>
        {{ gerandoPdf() ? 'Gerando PDF...' : 'Baixar PDF' }}
      </button>
    </div>
    }
  </div>

  <ng-container [ngTemplateOutlet]="barraFiltros"></ng-container>

  @if (unica(); as item) {
  <app-detalhe-solicitacao #detalhePdf [solicitacao]="item" (atualizada)="aoAtualizarSolicitacao($event)"></app-detalhe-solicitacao>
  } @else if (semProtocolo()) {
  <ng-container [ngTemplateOutlet]="semProtocoloFiltrado"></ng-container>
  } @else {
  <ng-container [ngTemplateOutlet]="semResultadoDoFiltro"></ng-container>
  }
  }
</div>

<dialog #modalDetalhe class="acompanhar-modal" aria-labelledby="modal-detalhe-titulo">
  @if (selecionada(); as item) {
  <div class="acompanhar-modal-conteudo">
    <div class="acompanhar-modal-topo">
      <div>
        <h2 class="acompanhar-modal-titulo" id="modal-detalhe-titulo">Andamento da Solicitação</h2>
        <p class="acompanhar-modal-protocolo">Protocolo: {{ item.protocolo }}</p>
      </div>

      <button type="button" class="acompanhar-modal-fechar" (click)="fecharDetalhe()" aria-label="Fechar">
        <i-lucide name="x" size="20" aria-hidden="true"></i-lucide>
      </button>
    </div>

    <app-detalhe-solicitacao class="detalhe-empilhado" [solicitacao]="item" (atualizada)="aoAtualizarSolicitacao($event)"></app-detalhe-solicitacao>

    <div class="acompanhar-modal-acoes">
      <button type="button" class="acompanhar-acao" (click)="fecharDetalhe()">
        <i-lucide name="arrow-left" size="16" aria-hidden="true"></i-lucide>
        Voltar
      </button>
    </div>
  </div>
  }
</dialog>

<dialog #modalServicos class="acompanhar-modal acompanhar-modal-estreito" aria-labelledby="modal-servicos-titulo">
  <div class="acompanhar-modal-conteudo">
    <div class="acompanhar-modal-topo">
      <div>
        <h2 class="acompanhar-modal-titulo" id="modal-servicos-titulo">Serviços vinculados</h2>
        <p class="acompanhar-modal-protocolo">
          Marque um ou mais serviços que deseja acompanhar. Sem nenhum marcado, todos são considerados.
        </p>
      </div>

      <button type="button" class="acompanhar-modal-fechar" (click)="fecharModalServicos()" aria-label="Fechar">
        <i-lucide name="x" size="20" aria-hidden="true"></i-lucide>
      </button>
    </div>

    <div class="acompanhar-entrada">
      <i-lucide class="acompanhar-entrada-icone" name="search" size="18" aria-hidden="true"></i-lucide>
      <input class="acompanhar-entrada-input" type="text" autocomplete="off" placeholder="Buscar serviço"
        aria-label="Buscar serviço" [value]="buscaServico()" (input)="aoBuscarServico($event)" />
    </div>

    <div class="acompanhar-vinculos-topo">
      <p class="acompanhar-ajuda" role="status">{{ resumoEscolha() }}</p>

      <div class="acompanhar-vinculos-atalhos">
        <button type="button" class="acompanhar-vinculo-atalho" [disabled]="!servicosFiltrados().length"
          (click)="marcarTodosServicos()">
          Marcar todos
        </button>

        <button type="button" class="acompanhar-vinculo-atalho" [disabled]="!servicosEmEscolha().length"
          (click)="limparSelecaoServicos()">
          Limpar seleção
        </button>
      </div>
    </div>

    <fieldset class="acompanhar-vinculos" [attr.aria-busy]="carregandoServicos()">
      <legend class="acompanhar-oculto">Serviços disponíveis</legend>

      @if (carregandoServicos()) {
      <p class="acompanhar-ajuda" role="status">Carregando os serviços...</p>
      } @else if (falhouServicos()) {
      <div class="acompanhar-erro-consulta acompanhar-vinculos-falha" role="alert">
        <p>Não foi possível carregar os serviços agora. Tente novamente em instantes.</p>
        <button type="button" class="acompanhar-vinculo-atalho" (click)="recarregarServicos()">
          Tentar novamente
        </button>
      </div>
      } @else {
      @for (servico of servicosFiltrados(); track servico) {
      <label class="acompanhar-vinculo-opcao">
        <input type="checkbox" [value]="servico" [checked]="servicoMarcado(servico)"
          (change)="alternarServico(servico)" />
        <span>{{ servico }}</span>
      </label>
      } @empty {
      <p class="acompanhar-ajuda">
        {{ buscaServico().trim() ? 'Nenhum serviço encontrado para a busca.' : 'Nenhum serviço publicado até o momento.' }}
      </p>
      }
      }
    </fieldset>

    <div class="acompanhar-modal-acoes acompanhar-modal-acoes-fim">
      <button type="button" class="acompanhar-acao" (click)="fecharModalServicos()">Cancelar</button>

      <button type="button" class="acompanhar-acao acompanhar-acao-primaria" (click)="confirmarServicos()">
        Confirmar serviços
      </button>
    </div>
  </div>
</dialog>

<ng-template #barraFiltros>
  <section class="acompanhar-filtros" aria-label="Consultar outro protocolo ou refinar o resultado">
    <div class="acompanhar-filtros-grade">
      <div class="acompanhar-campo">
        <label class="acompanhar-rotulo" for="filtro-protocolo">Protocolo</label>
        <input id="filtro-protocolo" class="acompanhar-select" type="text" placeholder="Ex: PM-2026-XXXXX"
          aria-describedby="filtro-protocolo-ajuda" [value]="rascunho().protocolo"
          (input)="aoFiltrar('protocolo', $event)" />
        <p class="acompanhar-ajuda" id="filtro-protocolo-ajuda">
          Digite outro protocolo para consultar sem voltar ao início.
        </p>
      </div>

      <div class="acompanhar-campo">
        <label class="acompanhar-rotulo" for="filtro-categoria">Serviço</label>
        <select id="filtro-categoria" class="acompanhar-select" [value]="rascunho().categoria"
          (change)="aoFiltrarCategoria($event)">
          <option value="">Todos os Serviços</option>
          @for (categoria of categoriasDisponiveis; track categoria.id) {
          <option [value]="categoria.id">{{ categoria.rotulo }}</option>
          }
        </select>

        @if (rascunho().categoria === 'servico') {
        <button type="button" class="acompanhar-vinculo" (click)="abrirModalServicos()"
          [attr.aria-label]="servicosSelecionados().length
            ? 'Serviços vinculados selecionados: ' + servicosSelecionados().join(', ') + '. Alterar seleção.'
            : 'Escolher serviços vinculados'">
          <i-lucide name="list-filter" size="14" aria-hidden="true"></i-lucide>
          <span class="acompanhar-vinculo-texto">{{ resumoServicos() }}</span>
        </button>
        }
      </div>

      <div class="acompanhar-campo">
        <label class="acompanhar-rotulo" for="filtro-status">Status</label>
        <select id="filtro-status" class="acompanhar-select" [value]="rascunho().status"
          (change)="aoFiltrar('status', $event)">
          <option value="">Todos os Status</option>
          @for (opcao of statusDisponiveis; track opcao.id) {
          <option [value]="opcao.id">{{ opcao.rotulo }}</option>
          }
        </select>
      </div>

      <div class="acompanhar-campo">
        <label class="acompanhar-rotulo" for="filtro-data-inicial">Data inicial</label>
        <input id="filtro-data-inicial" class="acompanhar-select" type="date" [value]="rascunho().dataInicial"
          (change)="aoFiltrar('dataInicial', $event)" />
      </div>

      <div class="acompanhar-campo">
        <label class="acompanhar-rotulo" for="filtro-data-final">Data final</label>
        <input id="filtro-data-final" class="acompanhar-select" type="date" [value]="rascunho().dataFinal"
          (change)="aoFiltrar('dataFinal', $event)" />
      </div>
    </div>

    <div class="acompanhar-filtros-acoes">
      <button type="button" class="acompanhar-acao" [disabled]="!temFiltroAtivo()" (click)="limparFiltros()">
        Limpar filtros
      </button>

      <button type="button" class="acompanhar-acao acompanhar-acao-primaria" (click)="filtrar()">
        Filtrar
      </button>
    </div>
  </section>
</ng-template>

<ng-template #semProtocoloFiltrado>
  <section class="acompanhar-vazio acompanhar-vazio-embutido" aria-labelledby="sem-protocolo-titulo">
    <span class="acompanhar-vazio-icone" aria-hidden="true">
      <i-lucide name="triangle-alert" size="40"></i-lucide>
    </span>

    <h2 class="acompanhar-vazio-titulo" id="sem-protocolo-titulo">Nenhum protocolo filtrado.</h2>

    <p class="acompanhar-vazio-texto">
      Informe um número de protocolo no campo acima e clique em Filtrar para consultar o andamento
      da manifestação.
    </p>
  </section>
</ng-template>

<ng-template #semResultadoDoFiltro>
  <section class="acompanhar-vazio acompanhar-vazio-embutido" aria-labelledby="sem-resultado-titulo">
    <span class="acompanhar-vazio-icone" aria-hidden="true">
      <i-lucide name="triangle-alert" size="40"></i-lucide>
    </span>

    <h2 class="acompanhar-vazio-titulo" id="sem-resultado-titulo">Nenhum resultado para os filtros.</h2>

    <p class="acompanhar-vazio-texto">
      Nenhuma manifestação deste protocolo corresponde ao serviço, status ou período informados.
    </p>

    <button type="button" class="acompanhar-acao acompanhar-acao-primaria" (click)="limparFiltros()">
      Limpar filtros
    </button>
  </section>
</ng-template>